import BannerService from '../services/banner/bannerService';
import { BannerDto } from '../services/banner/dto/bannerDto';
import { CrudStoreBase } from './crudStoreBase';

class BannerStore extends CrudStoreBase<BannerDto>{
  constructor() {
    super(BannerService, defaultBanner)
  }

  public async create(createUserInput: BannerDto) {
    return BannerService.create(createUserInput);
  }

  public resetDataSet() {
    this.dataSet = {
        totalCount: 0,
        items: [],
    };
  }
}

export const defaultBanner = {
  id: '',
  text1: '',
  text2: '',
  backgroundColor: '',
  redirectUrl: '',
  activeUntil: '',
  alwaysActive: false,
  isExternalLink: false,
  routeId: 0,
}

export default BannerStore;